/**
 * Shared looks for controls inside sequence nodes (design-studio "Sequence nodes", graph B6):
 * 36px squares with 6px corners and a quiet 1px border; Creator blue only for what is
 * open, focused or active.
 */

/** The "pick on map" square next to position/target dropdowns. */
export const NODE_PICK_BUTTON_BASE =
  "group flex h-[36px] w-[36px] flex-none items-center justify-center rounded-[6px] border border-solid transition-colors duration-150 ";
export const NODE_PICK_BUTTON_ACTIVE =
  "border-creator-primary bg-creator-primary text-white shadow-[0_0_0_3px_rgba(58,196,255,0.18)]";
export const NODE_PICK_BUTTON_IDLE =
  "border-creator-border bg-creator-surface text-creator-primary hover:bg-creator-primary-washed";

/** Text and number inputs: the same box as the square dropdown trigger. */
export const NODE_FIELD_BOX =
  "flex w-full items-center h-[36px] rounded-[6px] border border-solid bg-creator-surface px-[2px] transition-[border-color,box-shadow] duration-150";
export const NODE_FIELD_IDLE = "border-creator-border hover:border-creator-text-soft";
export const NODE_FIELD_FOCUSED = "border-creator-primary shadow-[0_0_0_3px_rgba(58,196,255,0.15)]";
